<div class="header pt-3">
  <div class="container-fluid">
    <div class="row">
      <div
        class="cols-lg-1 col-md-1 cols-sm-12 text-lg-left text-md-left text-center"
      >
        <div class="site-logo">
          <a class="navbar-brand text-sm-center" routerLink="/home">
            <img
              src="/assets/images/bjmc_logo.png"
              alt=""
              loading="lazy"
              height="65"
            />
          </a>
        </div>
      </div>
      <div
        class="cols-lg-6 col-md-6 cols-sm-12 text-lg-left text-md-left text-center"
      >
        <div class="site-text">
          <a routerLink="/home">
            <p class="site-title notranslate" style="font-size: 1.5rem">
              Byramjee Jeejeebhoy Government Medical College <br />
              and Sassoon General Hospitals, Pune
            </p>
          </a>
        </div>
      </div>
      <div
        class="cols-lg-5 col-md-5 cols-sm-12 mt-2 mb-2 text-lg-right text-md-right text-center"
      >
        <div class="contact-info">
          <p style="margin-right: 20px">
            <i
              class="fa fa-phone"
              aria-hidden="true"
              style="margin-right: 7px"
            ></i>
            <a
              href="tel:>020 26128000"
              style="color: white; text-decoration: none; font-size: 16px"
              >020 26128000</a
            >
          </p>
        </div>
        <div class="contact-info">
          <p>
            <i
              class="fa fa-envelope"
              aria-hidden="true"
              style="margin-right: 7px"
            ></i>
            <a
              href="mailto: deanbjmcpune@gmail.com"
              style="color: white; text-decoration: none; font-size: 16px"
              >deanbjmcpune@gmail.com</a
            >
          </p>
        </div>
        <div id="google_translate_element"></div>
      </div>
    </div>
  </div>
</div>
